module.exports = __webpack_public_path__ + "static/img/bio-availability.fd888dea.png";